'use client'

import {
    type AllHTMLAttributes,
    cloneElement,
    type ElementType,
    isValidElement,
    useState,
} from 'react'

import cn from 'clsx'
import HtmlToReact from 'html-react-parser'

import type { Themes } from '@/Theme'
import { Box } from '@/components/Box/Box'

import { createElement } from './createElement'

import css from './HtmlArticle.module.css'

export interface HtmlArticleProps extends AllHTMLAttributes<HTMLElement> {
    tag?: ElementType
    html?: string
    theme: Themes
    initialPlatform?: string
    onPlatformChanged?: (platform: string) => void
}

export function HtmlArticle({
    tag = 'article',
    html,
    className,
    theme,
    initialPlatform,
    onPlatformChanged,
    children,
    ...rest
}: HtmlArticleProps) {
    const [selectedPlatform, setSelectedPlatform] = useState(initialPlatform)

    return (
        <Box tag={tag} className={cn(css.content, { [css[theme]]: theme }, className)} {...rest}>
            {html
                ? HtmlToReact(html, {
                      library: {
                          createElement: createElement(
                              selectedPlatform,
                              (newPlatform) => {
                                  setSelectedPlatform(newPlatform)

                                  if (onPlatformChanged) {
                                      onPlatformChanged(newPlatform)
                                  }
                              },
                              theme,
                          ),
                          cloneElement: cloneElement,
                          isValidElement: isValidElement,
                      },
                  })
                : children}
        </Box>
    )
}
